import styled from "styled-components";
import { Box } from "vqp-common";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  min-height: 100vh;
`;

export const WrapperModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 2rem;
`;

export const Card = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
`;

export const SubTitle = styled.div`
    display: flex;
    flex-direction: row;
    font-size: 14px;
    font-weight: 700;
    width: 100%;

    > div{
        cursor: pointer;
        margin-right: 1rem;
        color: ${(props) => props.theme.colors.textBold};

        &.selected{
            color: ${(props) => props.theme.colors.primary}
            border-bottom: 2px solid;
            padding-bottom: 5px;
        }
    }
`;

export const H2 = styled.h2`
  font-size: 16px;
  font-style: italic;
`;

export const Div = styled.div`
  display: flex;
  flex-direction: column;

  &.exception {
    width: 100%;
  }
`;

export const DivIcon = styled.div`
  display: flex;
  flex-direction: row;
  width: 560px;
  justify-content: center;
  margin: 1rem 0;
`;

export const DivBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  width: 250px;
`;

export const BoxReplicate = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 222px;
  height: 222px;
  border: 5px solid #f7f7f7;
  border-radius: 12px;
  padding: 0 20px;
  cursor: pointer;
  margin-right: 1rem;
  -webkit-box-shadow: 4px 4px 6px 0px rgba(214, 214, 214, 1);
  -moz-box-shadow: 4px 4px 6px 0px rgba(214, 214, 214, 1);
  box-shadow: 4px 4px 6px 0px rgba(214, 214, 214, 1);

  &.selected {
    border: 5px solid ${(props) => props.theme.colors.success};
  }
`;

export const BoxSummary = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 160px;
  width: 560px;
  border: 5px solid #f7f7f7;
  border-radius: 12px;
  padding: 0 20px;
  cursor: pointer;
  margin-right: 1rem;
  -webkit-box-shadow: 4px 4px 6px 0px rgba(214, 214, 214, 1);
  -moz-box-shadow: 4px 4px 6px 0px rgba(214, 214, 214, 1);
  box-shadow: 4px 4px 6px 0px rgba(214, 214, 214, 1);

  &.selected {
    border: 5px solid ${(props) => props.theme.colors.success};
  }
`;

export const ModalTitle = styled.h1`
  font-size: 16px;
  color: #545454;
  margin-top: 20px;
`;

export const ReplicateTitle = styled.h1`
  font-size: 16px;
  color: #949494;
  margin-top: 10px;
`;

export const ReplicateSubtitle = styled.div`
  text-align: center;
  color: #949494;
  font-size: 13px;
`;

export const ReplicateSubtitleSummary = styled.div`
  color: #949494;
  font-size: 13px;
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: 1rem 0;
`;

export const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 2rem;
`;

export const Label = styled.label`
  margin-top: 10px;
  font-size: 14px;
  font-weight: bold;
`;

export const EditButton = styled.button`
  border: none;
  background-color: transparent;
  color: #c2121f;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
`;

export const LoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 2;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
`;
